module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('popup-picker', {
    attrs: {
      "fixed-columns": _vm.hideDistrict ? 2 : 0,
      "columns": 3,
      "data": _vm.list,
      "title": _vm.title,
      "show-name": "",
      "inline-desc": _vm.inlineDesc,
      "placeholder": _vm.placeholder,
      "value-text-align": _vm.valueTextAlign,
      "confirm-text": _vm.confirmText,
      "cancel-text": _vm.cancelText,
      "display-format": _vm.displayFormat
    },
    on: {
      "on-hide": _vm.emitHide,
      "on-show": function($event) {
        _vm.$emit('on-show')
      }
    },
    model: {
      value: (_vm.currentValue),
      callback: function($$v) {
        _vm.currentValue = $$v
      },
      expression: "currentValue"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15dffbef"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/x-address/index.vue
// module id = 472
// module chunks = 4